import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20warm%20gradient%20in%20deep%20crimson%20and%20dark%20charcoal%20tones%2C%20soft%20geometric%20shapes%20floating%2C%20subtle%20particle%20effects%2C%20modern%20streaming%20platform%20atmosphere%2C%20dark%20elegant%20aesthetic%20with%20warm%20ambient%20lighting%2C%20professional%20cinematic%20composition%2C%208K%20quality&width=1600&height=800&seq=hero-bg-91video&orientation=landscape"
        alt="91视频在线观看 - 高清视频免费播放平台"
        className="absolute inset-0 w-full h-full object-cover"
        title="91视频在线观看 - 高清视频免费播放平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight">
            海量高清视频
            <br />
            <span className="text-primary-400">随心看</span>
          </h1>
          <p className="mt-4 md:mt-6 text-sm md:text-lg text-background-200/80 max-w-xl mx-auto leading-relaxed">
            无需下载，即点即播。电影、电视剧、综艺、动漫、纪录片——你想看的，这里都有。
          </p>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg"></i>
              立即观看
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm border border-background-50/20 hover:bg-background-50/25 transition-colors whitespace-nowrap"
            >
              <i className="ri-information-line text-lg"></i>
              了解更多
            </Link>
          </div>
          <div className="mt-8 md:mt-10 flex items-center justify-center gap-6 md:gap-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">5000<span className="text-primary-400">万+</span></div>
              <div className="text-xs md:text-sm text-background-300 mt-1">日均活跃用户</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">100<span className="text-primary-400">万+</span></div>
              <div className="text-xs md:text-sm text-background-300 mt-1">视频资源总量</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">98.5<span className="text-primary-400">%</span></div>
              <div className="text-xs md:text-sm text-background-300 mt-1">用户好评率</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}